import React, { useState } from 'react';
import { CalculatorsType } from '../ConstantsEN';
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from '../Helmet';
import MainCalculatorsList from '../MainCalculators';
const TITLE = 'Friction Force Calculator - Calculate Frictional Force Online';
const DESCRIPTION = 'The Friction Force Calculator calculates the frictional force based on acceleration and mass.';
const KEYWORDS = 'frictional force, calculate frictional force, friction force calculator';
const OG_URL = 'https://do-calculate.com/calculator/en/frictionforce';
function FrictionForceCalculator() {
    const [acceleration, setAcceleration] = useState('');
    const [mass, setMass] = useState('');
    const [frictionalForce, setFrictionalForce] = useState('');
    const [error, setError] = useState('');
    const handleCalculate = () => {
        if (!acceleration || !mass) {
            setError('Please enter acceleration and mass correctly');
            setFrictionalForce('');
            return;
        }
        const accelerationValue = parseFloat(acceleration);
        const massValue = parseFloat(mass);
        if (isNaN(accelerationValue) || isNaN(massValue) || massValue <= 0) {
            setError('Please enter valid and positive values for acceleration and mass');
            setFrictionalForce('');
            return;
        }
        const frictionalForceValue = accelerationValue * massValue;
        setFrictionalForce(frictionalForceValue.toFixed(2));
        setError('');
    };
    return (
        <div className="ltr">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
                    </div>
                    <div>
                        <div className="row">
                            <div>
                                <p>
                                    To calculate frictional force, we need to know the acceleration and mass.
                                </p>
                                <p>
                                    Frictional force can be calculated using the following formula:
                                </p>
                                <p>
                                    <b>Frictional Force (F) = Acceleration (a) × Mass (m)</b>
                                </p>
                                <p>
                                    Where:<br />
                                    F: Frictional Force (in Newtons - N).<br />
                                    a: Acceleration (in meters per second squared - m/s²).<br />
                                    m: Mass (in kilograms - kg).
                                </p>
                                <p>
                                    Use the following calculator to calculate frictional force based on acceleration and mass.
                                </p>
                            </div>
                        </div>
                         <MobileUnderCalAds/>
                        <div className="row">
                            <div className="col-sm-12 col-md-7 calculatorStyle">
                                <div className='p-3 mb-2 bg-success text-white'>
                                    <h2 style={{ fontSize: '16px' }}>{TITLE}</h2>
                                </div>
                                <hr />
                                <div dir="ltr">
                                    <div>
                                        <div className="form-group d-flex align-items-center">
                                            <b>
                                                <label className="form-label ms-2">Acceleration (m/s²)</label>
                                            </b>
                                            <input
                                                type="number"
                                                placeholder="9.8"
                                                value={acceleration}
                                                onChange={(e) => setAcceleration(e.target.value)}
                                                className="form-control"
                                                style={{ width: '150px' }}
                                            />
                                        </div>
                                        <br />
                                        <div className="form-group d-flex align-items-center">
                                            <b>
                                                <label className="form-label ms-2">Mass (kg)</label>
                                            </b>
                                            <input
                                                type="number"
                                                placeholder="10"
                                                value={mass}
                                                onChange={(e) => setMass(e.target.value)}
                                                className="form-control"
                                                style={{ width: '150px' }}
                                            />
                                        </div>
                                        <br />
                                        <button
                                            className="btn btn-success"
                                            style={{ fontSize: '20px' }}
                                            onClick={handleCalculate}
                                        >
                                            Calculate Frictional Force
                                        </button>
                                    </div>
                                    <br />
                                    <div>
                                        {error !== '' ? (
                                            <p className='p-3 mb-2 bg-warning text-white'>Error: {error}</p>
                                        ) : (
                                            <>
                                                {frictionalForce !== '' && (
                                                    <>
                                                        <p className='p-3 mb-2 bg-success text-white'>
                                                            Frictional Force (Newtons): {frictionalForce} N
                                                        </p>
                                                        <p className='p-3 mb-2 bg-info text-black'>
                                                            Thrust Force = Resultant Force - Kinetic Frictional Force
                                                        </p>
                                                    </>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col">
                    <SecondAds />
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.physicsCalculators} />
                    <br />
                </div>
            </div>
            <br />
        </div>
    );
}
export default FrictionForceCalculator;
